export const LABEL_INDENTS = {
  INDENT_10: '--label-indents-10',
} as const
export type LABEL_INDENTS = (typeof LABEL_INDENTS)[keyof typeof LABEL_INDENTS]
